import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { setQuery, setSelect, setUrl } from '../../store/reducers/dataSlice';
import Table from '../../components/Table';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Spin, Tooltip } from 'antd';
import { setSelectedMenu } from '../../store/reducers/uiSlice';

function TypesPage(props) {
  const [count, setCount] = useState(null);

  useEffect(() => {
    props.setSelectedMenu('41');

    props.setUrl('/product-types');
    props.setSelect(`Deleted=0&`);
    props.setQuery('&_sort=id:DESC');

    axios
      .get(`/product-types/count?&Deleted=0&`)
      .then((res) => setCount(res.data))
      .catch((e) => console.log(e));
  }, [props]);

  const columns = [
    {
      title: 'Type Name',
      dataIndex: 'Name',
      key: 'Name',
      render: (text) => (text ? text : 'N/A'),
      sorter: {},
      searchable: true,
      width: 350,
    },
    {
      title: 'Description',
      dataIndex: 'Description',
      key: 'Description',
      render: (text) => (text ? text : 'N/A'),
      sorter: {},
      searchable: true,
    },
    {
      title: '',
      dataIndex: 'Name',
      key: 'Name',
      render: (text, rec) => (
        <Tooltip title="View">
          <Link to={`/products/types/${rec.id}`}>
            <img src="/vectors/eye.png" alt="" />
          </Link>
        </Tooltip>
      ),
      width: 50,
    },
  ];

  return (
    <div className="types-page">
      <h2 className="title">Product Types</h2>
      <Spin spinning={count === null}>
        {count ? (
          <>
            <Link to={'/products/types/new'}>
              <div className="btn" style={{ marginBottom: '20px' }}>
                Add Type
              </div>
            </Link>

            <Table columns={columns} scroll={{ x: 600 }} />
          </>
        ) : (
          <>
            <div className="empty-table">
              <div className="wrapper">
                <h3>— Your types is empty —</h3>

                <Link to={`/products/types/new`} style={{ color: 'white' }}>
                  <div className="btn">Add types</div>
                </Link>
              </div>
            </div>
          </>
        )}
      </Spin>
    </div>
  );
}

function mapDispatchToProps(dispatch) {
  return {
    setUrl: (url) => dispatch(setUrl(url)),
    setSelect: (q) => dispatch(setSelect(q)),
    setQuery: (q) => dispatch(setQuery(q)),

    setSelectedMenu: (id) => dispatch(setSelectedMenu(id)),
  };
}
export default connect(null, mapDispatchToProps)(TypesPage);
